import { render } from "./DesignItemEditButton.vue?vue&type=template&id=f78f593c"
import script from "./DesignItemEditButton.vue?vue&type=script&lang=js"
export * from "./DesignItemEditButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__